import { oldContactsPath } from 'contacts/routes/routePaths';
import { goTo } from 'coreOld/utils';
import { jobListPath } from 'jobs/routes/routePaths';
import { oldProjectListPath } from 'projectsOld/routes/routePaths';
import { oldCustomerQuotesPath } from 'quotes/routes/routePaths';

export const buttonsConfig = (translate) => [
  {
    label: translate('buttonLabelSetupCustomer'),
    onClick: () => goTo(oldContactsPath()),
  },
  {
    label: translate('buttonLabelCreateProject'),
    onClick: () => goTo(oldProjectListPath()),
  },
  {
    label: translate('buttonLabelCreateBom'),
    url: jobListPath(),
  },
  {
    label: translate('buttonLabelCreateQuote'),
    onClick: () => goTo(oldCustomerQuotesPath()),
  },
];
